import { mapState, mapMutations, createNamespacedHelpers } from "vuex";
import { countDown, conversion, addZero } from "@/tool";
import { format_date } from "@/filters/format_date";
import { format_case_name } from "@/filters/format_case_name";

import CustomButton from "@/partials/custom_button";
import { CustomBlockTitle } from "@/partials/custom_block_title";
import Button from "@/components/button";
import Picture from "@/components/picture";
import BlockPanel from "@/components/block_panel";
import Award from "@/components/award";
import LiveDropBox from "@/partials/live_drop_box";
import InteractivePanel from "@/components/interactive_panel";
import NoticeBoard from "@/components/noticeboard/index.vue";
import Number from "@/components/AnimateNumber/index.vue";
import NewMultiplePeopleCase from "../../multiplePeopleCase/components/NewCase.vue";
import * as apis from "@/api";
import countDownModel from "@/components/countDown";
import {
  GetItemDuration,
  GetItemName,
  GetItemSkinName,
  timeToCounter,
} from "@/tool";

import { roll_list } from "@/api";
import { CaseImg } from "@/components/UI";
import caseItem from "@/components/caseItem/index.vue";
import gameInstanceBox from "../../gameInstanceBox/index.vue";

const { mapActions: RollRoomsMapActions, mapGetters: RollRoomsMapGetters } =
  createNamespacedHelpers("roll_rooms");

export default {
  data() {
    return {
      Alert: false,
      active_cate_index: 0,
      price_range_index: 0,
      price_range: [
        { min: 0, max: 99999999 },
        { min: 0, max: 1 },
        { min: 2, max: 19 },
        { min: 20, max: 49 },
        { min: 50, max: 99 },
        { min: 100, max: 999999 },
      ],
      /** 注销首页Roll房刷新 */
      roll_room_list: [],
      boxList: [],
      multiplePeople_cases_rules_show: false,
      new_multiplePeople_cases_show: false,
      deadline2: Date.now() + 1000 * 60 * 60 * 8,
      battleCaseList: [],
      caseData: [],
      multiplePeopleCaseRecentList: [],
      isRequest: false,
      mpcCaseSettings: {},
      active_cate: "all",
      price_range_value: "all",
      price_sort_index: "all",
      risk_sort_index: "all",
      price_range_list: [
        {
          label: "所有",
          value: "all",
          min: 0,
          max: 99999999,
        },
        {
          label: "0 — 1",
          value: "01",
          min: 0,
          max: 1,
        },
        {
          label: "2 — 19",
          value: "219",
          min: 2,
          max: 19,
        },
        {
          label: "20 — 49",
          value: "2049",
          min: 20,
          max: 49,
        },
        {
          label: "50 — 99",
          value: "5099",
          min: 50,
          max: 99,
        },
        {
          label: "100+",
          value: "100",
          min: 100,
          max: 999999,
        },
      ],
      price_sort_list: [
        {
          label: "价格降序",
          value: "descending",
        },
        {
          label: "价格升序",
          value: "ascending",
        },
      ],
      risk_sort_list: [
        {
          label: "L",
          value: "0",
        },
        {
          label: "M",
          value: "1",
        },
        {
          label: "H",
          value: "2",
        },
        {
          label: "l",
          value: "3",
        },
      ],
      mpcCaseSettings: {},
      mpcCaseTimer: null, // 用于存储计时器对象
      battleChallengeDetail: {
        isChallengeEnable: false,
      },
      isShowShaixuan: false,
      shouldRestoreScroll: false,
      savedScrollTop: 0,
    };
  },
  components: {
    "p-custom-button": CustomButton,
    "p-custom-block-title": CustomBlockTitle,
    "p-live-drop-box": LiveDropBox,
    "c-button": Button,
    "c-picture": Picture,
    "c-block-panel": BlockPanel,
    "c-award": Award,
    "c-notice-board": NoticeBoard,
    "c-number": Number,
    "c-caseimg": CaseImg,
    "c-interactive-panel": InteractivePanel,
    "c-new-multiple-people-case": NewMultiplePeopleCase,
    "c-countDown": countDownModel,
    "c-case-item": caseItem,
    "c-gameInstanceBox": gameInstanceBox,
  },
  filters: {
    conversion,
    addZero,
    countDown,
    format_date,
    format_case_name,
    GetItemDuration,
    GetItemName,
    GetItemSkinName,
    timeToCounter,
  },
  computed: {
    ...RollRoomsMapGetters(["home_roll_rooms"]),
    ...mapState([
      "config",
      "loginModal",
      "banner_list",
      "user",
      "notice_list",
      "GobalInfo",
      "currentCate",
    ]),
    curUserRealId() {
      return parseInt(this.user.id );
    },
    cateCaseList() {
      let price_range_item = {};
      this.price_range_list.forEach((item) => {
        if (item.value == this.price_range_value) {
          price_range_item = item;
          return;
        }
      });
      return (cate) => {
        if (!this.boxList || !this.boxList.list) {
          return [];
        }
        let newArr = [];
        return this.boxList.list.filter(
          (_) =>
            (_.catagory == cate ||
              (cate == "all" && _.catagory != "副本箱列表")) &&
            _.price >= price_range_item.min &&
            _.price <= price_range_item.max &&
            (_.riskLevel == this.risk_sort_index ||
              this.risk_sort_index == "all")
        );
      };
    },
  },
  watch: {
    async isHappyCoin(val, oldVal) {
      if (val === oldVal) return;
      await this.getboxList();
      await this.getGameInstanceBoxList();
      this.getCaseList();
    },
    "loginModal.isLoginSuccess": {
      async handler(val) {
        console.log("val==", val);
        if (val == "success") {
          this.isRequest = false;
          await this.onInitData();
          this.loginModal.isLoginSuccess = null;
        }
      },
      deep: true,
      immediate: true,
    },
    price_sort_index: {
      handler(val) {
        if (val == "descending") {
          this.boxList.list.sort((a, b) => b.price - a.price);
        } else if (val == "ascending") {
          this.boxList.list.sort((a, b) => a.price - b.price);
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await this.onInitData();
    const meta = this.$route.meta
    if (meta && meta.pendingScroll) {
      window.scrollTo({
        top: meta.pendingScroll.y,  // 使用保存的滚动位置 
      })
    }
    //监听MPCaseFinished 开箱成功通知
    this.onListenMPCaseFinished();
    //监听多人开箱倒计时
    this.countdownHandle();
  },
  beforeDestroy() {
    if (this.mpcCaseTimer) {
      clearInterval(this.mpcCaseTimer);
    }
  },
  activated() {
    if (!this.shouldRestoreScroll) return;
    this.shouldRestoreScroll = false;
    this.restorePageScroll();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "case" || to.name === "happyCoinCase") {
      this.savedScrollTop = this.getPageScrollTop();
      this.shouldRestoreScroll = true;
    } else {
      this.shouldRestoreScroll = false;
      this.savedScrollTop = 0;
    }
    next();
  },
  methods: {
    ...RollRoomsMapActions(["refresh_home_roll_rooms"]),
    async onInitData() {
      await this.getboxList();
      // 获取首页箱子列表
      await this.getGameInstanceBoxList();
      //多人集资开箱列表
      await this.getMultiplePeopleCaseRecentList();
      // 刷新Roll房信息
      await this.getRollRoomList();
      await this.initmpCaseHub();
      await this.initBattleHub();
      setTimeout(async () => {
        await this.getMPCaseSettings();
      }, 1000);
    },
    async getboxList() {
      let _this = this;
      let params = {};
      if (this.isHappyCoin) {
        params.tagId = 3;
      }
      const boxList_response = await apis.boxList(params);
      if (boxList_response.data.code !== 0) {
        return;
      }
      _this.boxList = boxList_response.data.data;
      console.log("_this.boxList==", _this.boxList);
    },
    async getGameInstanceBoxList() {
      let _this = this;
      _this.cateCaseList("副本箱列表").forEach(async (boxItem, boxIndex) => {
        // 如果存在对应副本箱，副本加个字段，首页显示
        boxItem["isAccumulateExtraCasesShow"] = false;
        _this.boxList.list.forEach(async (items) => {
          //是否有累计副本箱=母箱
          if (
            items.isEnableAccumulateCase &&
            items.accumulateExtraCaseId &&
            items.accumulateExtraCaseId == boxItem.caseId
          ) {
            items.awardAccumulateExtraCases =
              items.awardAccumulateExtraCases.filter((res) => {
                return res.extraCaseId == items.accumulateExtraCaseId;
              });
            //如果存在对应副本箱，副本加个字段，首页显示
            if (items.awardAccumulateExtraCases.length > 0) {
              boxItem.isAccumulateExtraCasesShow = true;
            }
          }
        });
      });
    },
    countdownHandle() {
      this.mpcCaseTimer = setInterval(() => {
        const now = Date.now();
        const end = new Date(this.mpcCaseSettings.mpCaseEndTime).getTime();
        const diff = end - now;
        if (diff <= 0) {
          clearInterval(this.mpcCaseTimer);
          // 倒计时结束
          this.getMPCaseSettings();
          return;
        }
      }, 1000);
    },
    async getMPCaseSettings() {
      const response = await apis.getMPCaseSettings();
      if (response.data.code !== 0) {
        return;
      }
      this.mpcCaseSettings = response.data.data;
      this.mpcCaseSettings.mpCaseEndTime = new Date(
        this.mpcCaseSettings.mpCaseEndTime
      ).getTime();
    },
    async getMultiplePeopleCaseRecentList() {
      let _this = this,
        params = {
          pageIndex: 1,
          pageSize: 100,
        };
      if (this.isRequest) return;
      this.isRequest = true;
      apis.multiplePeopleCaseRecentList(params).then((res) => {
        if (res.data.code !== 0) {
          return;
        }
        _this.multiplePeopleCaseRecentList = res.data.data.items.slice(0, 6);
        for (
          let index = 0;
          index < _this.multiplePeopleCaseRecentList.length;
          index++
        ) {
          const item = _this.multiplePeopleCaseRecentList[index];
          item["joinPrice"] = 0;
          item["joinRatio"] = 0;
          item.endTime = new Date(item.endTime).getTime();
          if (item.cases && item.cases.length == 1) {
            item["currentCaseName"] = item.cases[0].name;
          } else if (item.cases && item.cases.length > 1) {
            item.cases.sort((a, b) => b.price - a.price);
            item["currentCaseName"] = `${item.cases[0].name}...`;
          }
          if (item.players && item.players.length > 0) {
            item.players.forEach((player) => {
              player["ratio"] = `${Math.floor(
                (player.amount / item.price) * 100
              )}`;
              if (this.curUserRealId == player.id) {
                item.joinPrice = player.amount;
                item.joinRatio = player.ratio;
              }
            });
          }
        }
        setTimeout(() => {
          this.isRequest = false;
        }, 3000);
      });
    },
    //获取连胜挑战信息GCRequestChallengeInfo接口
    initBattleHub() {
      if (this.$caseBattleHub.conn.state == "Connected") {
        //连接存在
        this.CGReqBattleChallengeDetails();
      }
      this.$caseBattleHub.onConnected = () => {
        this.CGReqBattleChallengeDetails();
      };
      this.$caseBattleHub.onReconnected = () => {
        this.CGReqBattleChallengeDetails();
      };
    },
    CGReqBattleChallengeDetails() {
      this.$caseBattleHub.conn
        .invoke("GCRequestChallengeInfo")
        .then((cpMsg) => {
          console.log("获取连胜挑战信息==GCRequestChallengeInfo", cpMsg);
          this.battleChallengeDetail.isChallengeEnable =
            cpMsg.data.isChallengeEnable;
        });
    },
    initmpCaseHub() {
      if (this.$mpCaseHub.conn.state == "Connected") {
        console.log("已连接11");
        this.getCaseList();
      }

      this.$mpCaseHub.onConnected = () => {
        console.log("已连接22");
        this.getCaseList();
      };

      this.$mpCaseHub.onReconnected = () => {
        console.log("已连接33");
        this.getCaseList();
      };
    },
    onClickCaseItmHandle(type) {
      this.active_cate = type;
      this.$forceUpdate();
    },
    getPageScrollContainer() {
      return document.querySelector(".p-home.mobile-home") || window;
    },
    getPageScrollTop() {
      const container = this.getPageScrollContainer();
      if (container === window) {
        return (
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0
        );
      }
      return container.scrollTop || 0;
    },
    setPageScrollTop(top) {
      const container = this.getPageScrollContainer();
      if (container === window) {
        window.scrollTo({ top, behavior: "auto" });
        return;
      }
      container.scrollTo({ top, behavior: "auto" });
    },
    restorePageScroll() {
      const top = this.savedScrollTop;
      this.$nextTick(() => {
        setTimeout(() => {
          this.setPageScrollTop(top);
        }, 0);
      });
    },
    getCaseList() {
      this.caseData = [];
      this.battleCaseList = [];
      this.boxList.list.forEach((item) => {
        if (item.caseType == "0") {
          this.battleCaseList.push(item);
          let newObj = { ...item, count: 0 };
          this.caseData.push(newObj);
        }
      });
    },
    getRollRoomList() {
      roll_list({ type: 0, size: 3, page: 1 }).then((res) => {
        if (res.data.code === 0) {
          this.roll_room_list = [];
          res.data.data.forEach((item, index) => {
            if (item && item.items && item.items.length) {
              this.roll_room_list.push(item);
            }
          });
        }
      });
    },
    onListenMPCaseFinished() {
      this.$mpCaseHub.conn.on("MPCaseFinished", (data) => {
        console.log("监听收到开箱成功通知", data);
        let players = data.players.filter(
          (item) => item.id == this.curUserRealId
        );
        console.log("players==", players);
        if (players.length > 0) {
          this.$toast.success(`合开箱【${data.cases[0].name}】打开中~`);
          this.getMultiplePeopleCaseRecentList();
          setTimeout(() => {
            this.$toast.success(`合开箱【${data.cases[0].name}】已打开~`);
            return;
          }, 15000);
        }
      });
    },
    pathGo(obj) {
      if (obj.name === "case") {
        return this.$router.push({
          name: this.isHappyCoin ? "happyCoinCase" : "case",
          params: { id: obj.id },
          query: this.$route.query || {},
        });
      }
      const route = { ...obj };
      if (this.isHappyCoin && route.name === "battle") {
        route.name = "happyCoinBattle";
      }
      this.$router.push({ ...route, query: { ...(this.$route.query || {}), ...(route.query || {}) } });
    },
    openCreateRoomModal() {
      if (!this.user.nickname) return this.$store.commit("setloginModal", true);

      this.new_multiplePeople_cases_show = true;
    },
    async createNewMultiplepeopleCase(data) {
      let lpMsg = await this.$mpCaseHub.conn.invoke(
        "GCRequestCreateMPCase",
        data
      );
      if (lpMsg.success) {
        await this.$toast.success(lpMsg.data);
        await this.$refs.cNewMultiplepeopleCase.reset();
        this.new_multiplePeople_cases_show = false;
        await this.$store.commit("setInfo");
        await this.getMultiplePeopleCaseRecentList(); //获取房间列表
      } else {
        this.$toast.error(lpMsg.msg);
        this.$refs.cNewMultiplepeopleCase.reset();
      }
    },
    handleShowmultiplePeopleCaseDetail(item) {
      this.$router.push({
        name: this.isHappyCoin ? "happyCoinMultiplePeopleCaseDetail" : "multiplePeopleCaseDetail",
        params: { id: item.id },
        query: this.$route.query || {},
      });
    },
    /** swiper 自动播放切换 */
    async on_swiper_autoplay_toggle(swiper, event) {
      if (!swiper) return null;

      event.type === "mouseleave" && swiper.autoplay.start();

      event.type === "mouseenter" && swiper.autoplay.stop();
    },

    /** 更新箱子价格按钮状态 */
    async update_case_price_is_active({
      cases_category_index,
      case_item_index,
      is_active,
    }) {
      let case_price_ref =
        this.$refs[`case_price_${cases_category_index}_${case_item_index}`];
      case_price_ref = case_price_ref
        ? case_price_ref[0]
          ? case_price_ref[0]
          : null
        : null;

      if (case_price_ref === null) return;

      case_price_ref.update_button_is_active(is_active);
    },
    onShaixuanHandle() {
      this.isShowShaixuan = !this.isShowShaixuan;
    },
    onScrollLeft() {
      // 获取要滚动的元素
      let element = this.$refs.categoryItems;
      console.log("element==", element);
      // 滚动到水平位置100px
      element.scrollTo({
        left: 0, // 目标位置，相对于该元素的左边框
        behavior: "smooth", // 可选，平滑滚动效果
      });
    },
    onScrollRight() {
      // 获取要滚动的元素
      let element = this.$refs.categoryItems;
      console.log("element==", element);
      console.log("scrollWidth==1", element.scrollWidth);
      element.scroll({
        left: 500, // 向右滚动500像素
        top: 0, // 不改变垂直位置
        behavior: "smooth", // 平滑滚动效果
      });
      // element.scrollBy(500, 0); // 在当前位置向右滚动500像素
    },
  },
};
